import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { supabase } from '../supabaseClient';
import { whatsapp, formatKES } from '../utils/cacheUtils';
import SEO from '../components/SEO';

export default function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setNotFound(false);
    supabase
      .from('products')
      .select('*')
      .eq('id', id)
      .maybeSingle()
      .then(({ data }) => {
        if (!active) return;
        if (data) setProduct(data);
        else setNotFound(true);
        setLoading(false);
      });
    return () => { active = false; };
  }, [id]);

  if (loading) {
    return <div className="page container"><div className="loading-state">Loading product…</div></div>;
  }

  if (notFound || !product) {
    return (
      <div className="page container">
        <SEO title="Product not found | Jowey's" description="This product could not be found." path={`/shop/${id}`} />
        <div className="glass-card" style={{ maxWidth: 720, margin: '0 auto' }}>
          <h1>Product not found</h1>
          <p><Link to="/">Back to shop</Link></p>
        </div>
      </div>
    );
  }

  const imageUrl = product.image_url || product.imageUrl;
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: product.description,
    image: imageUrl,
    offers: {
      '@type': 'Offer',
      priceCurrency: 'KES',
      price: product.price,
      availability: 'https://schema.org/InStock',
    },
  };

  return (
    <div className="page container">
      <SEO
        title={`${product.name} | Jowey's Shop`}
        description={product.description}
        path={`/shop/${id}`}
        image={imageUrl}
        jsonLd={jsonLd}
      />
      <div className="glass-card" style={{ maxWidth: 720, margin: '0 auto' }}>
        <img className="product-detail-img" src={imageUrl} alt={product.name} />
        <h1 className="product-detail-title">{product.name}</h1>
        <p className="product-detail-desc">{product.description}</p>
        <div className="product-detail-price">{formatKES(product.price)}</div>
        <button className="btn btn-whatsapp" onClick={() => whatsapp.openWhatsApp(product)}>
          <FaWhatsapp /> Order via WhatsApp
        </button>
        <p style={{ marginTop: '1.5rem' }}><Link to="/">&larr; Back to shop</Link></p>
      </div>
    </div>
  );
}
